import { useNavigate } from "react-router-dom";
import { UnifiedSearchChat } from "@/components/navigation/UnifiedSearchChat";
import { LanguageToggle } from "@/components/LanguageToggle";
import { cn } from "@/lib/utils";
import { ComponentErrorBoundary } from "@/components/error/ComponentErrorBoundary";
import { FranklinLogo } from "@/components/ui/franklin-logo";

interface HeaderProps {
  /** Optional actions rendered before LanguageToggle */
  headerButtons?: React.ReactNode;
  className?: string;
  showSearch?: boolean;
  showLanguageToggle?: boolean;
  showMenuButton?: boolean;
}

export function Header({
  headerButtons,
  className,
  showSearch = true,
  showLanguageToggle = false,
}: HeaderProps) {
  const navigate = useNavigate();

  const handleLogoClick = () => {
    navigate("/buildings");
  };

  return (
    <div
      className={cn("fixed left-4 right-4 top-4 z-50 flex items-center justify-between", className)}
    >
      <div className="flex items-center gap-4">
        {/* Franklin Logo - navigates to buildings page */}
        <FranklinLogo
          size="md"
          showBorder={false}
          onClick={handleLogoClick}
          className="bg-transparent"
        />
        {showSearch && (
          <ComponentErrorBoundary fallbackMessage="Search unavailable">
            <UnifiedSearchChat className="opacity-75 transition-opacity hover:opacity-100" />
          </ComponentErrorBoundary>
        )}
      </div>
      <div className="flex items-center gap-2">
        {headerButtons && (
          <ComponentErrorBoundary fallbackMessage="Header actions unavailable">
            {headerButtons}
          </ComponentErrorBoundary>
        )}
        {showLanguageToggle && (
          <ComponentErrorBoundary fallbackMessage="Language toggle unavailable">
            <LanguageToggle />
          </ComponentErrorBoundary>
        )}
      </div>
    </div>
  );
}
